import axios from 'axios'
import xml2js from 'xml2js'
import store from '@/store'

const parser = new xml2js.Parser()
const practicesClient = axios.create({
  baseURL: process.env.VUE_APP_PRACTICE_API_URL,
})

export default practicesClient
